import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

export default function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <Card className="max-w-md w-full bg-slate-800 border-slate-700">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="w-20 h-20 mx-auto bg-yellow-500/20 rounded-full flex items-center justify-center mb-4">
            <XCircle className="w-12 h-12 text-yellow-500" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Pago cancelado</h2>
          <p className="text-slate-400 mb-6">
            Has cancelado el proceso de pago. No se ha realizado ningún cargo a tu tarjeta.
          </p>
          <div className="space-y-3">
            <Button 
              onClick={() => navigate('/#planes')}
              className="w-full bg-gradient-to-r from-cyan-500 to-blue-600"
            >
              Ver planes disponibles
            </Button>
            <Button 
              variant="outline"
              onClick={() => navigate('/')}
              className="w-full border-slate-600 text-slate-300 hover:bg-slate-700"
            >
              Volver al inicio
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
